import {createContext} from "react";


const ComputeOptimizerChangeContext = createContext({
    recommendationType: "",
    setRecommendationType: () => {
    }
});
export default ComputeOptimizerChangeContext;